const AUTH_RETRY_DELAY_MS = 400;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const dispatchAuthExpired = () => {
  window.dispatchEvent(
    new CustomEvent("auth-expired", {
      detail: {
        reason: "expired",
        message: "Your session has expired. Please log in again to continue.",
      },
    })
  );
};

export async function apiFetch(url, options = {}) {
  const { authRetry = true, logoutOnUnauthorized = true, ...fetchOptions } = options;

  const request = () => fetch(url, {
    credentials: "include",
    ...fetchOptions,
  });

  let res = await request();

  if (res.status === 401) {
    if (authRetry && !fetchOptions.signal?.aborted) {
      await wait(AUTH_RETRY_DELAY_MS);
      res = await request();
    }

    if (res.status !== 401) {
      return res;
    }

    if (!logoutOnUnauthorized) {
      return res;
    }

    dispatchAuthExpired();
    throw new Error("Session expired");
  }

  if (res.status === 403) {
    throw new Error("Access denied");
  }

  return res;
}
